import capitalize from 'lodash/capitalize'

import { AppMode } from '@/models/app'
import { resolveChannelAndModeFromUrl } from '@/utils/resolveChannelAndModeFromUrl'

// Pushes `Dominio` before React so GTM/GA see it earlier than `useEffect` in `DataLayer`
export function pushDominioBeforeRender(href: string): void {
  window.dataLayer = window.dataLayer || []
  const resolution = resolveChannelAndModeFromUrl(href)
  const mode = resolution?.mode ?? AppMode.WIDGET
  window.dataLayer.push({ Dominio: capitalize(mode) })
}
